import React from 'react';
import { DialogContent } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import CustomTextField from 'src/components/CustomTextField';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { useStyles } from './useStyles';
import { getChannelLabel } from 'src/data/channel';

export const Form = ({
  onInputUrlChange,
  onUrlChange,
  url,
  error,
  urlResources,
  isExtractingTalkingPointsView,
  type,
}) => {
  const styles = useStyles();

  return (
    <DialogContent className={styles.root}>
      <CustomTypography className={styles.label}>
        Detect {getChannelLabel(type).toLocaleLowerCase()} talking points from
      </CustomTypography>
      <Autocomplete
        options={urlResources}
        inputValue={url}
        onInputChange={onInputUrlChange}
        onChange={onUrlChange}
        getOptionLabel={(resource) => resource.content}
        renderInput={(params) => (
          <CustomTextField
            className={styles.textField}
            dataTestId="TPURLInput"
            placeholder="Enter a URL or select a resource"
            disabled={isExtractingTalkingPointsView}
            error={Boolean(error)}
            variant="outlined"
            {...params}
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        noOptionsText="No resources were accessed in this workspace."
        disabled={isExtractingTalkingPointsView}
        disableClearable
        freeSolo
      />
      {error && (
        <CustomTypography
          className={styles.error}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          {error}
        </CustomTypography>
      )}
    </DialogContent>
  );
};
